export default __webpack_public_path__ + "static/media/tak.23dd6072.png";